import React from 'react';
import { creators } from '../data/creators';
import { products } from '../data/products';
import { CategoryShowcase } from '../components/home/CategoryShowcase';
import { ConceptTeaser } from '../components/home/ConceptTeaser';
import { CreatorMarquee } from '../components/home/CreatorMarquee';
import { Hero } from '../components/home/Hero';
import { LastDaysCarousel } from '../components/home/LastDaysCarousel';
import { UpcomingCreators } from '../components/home/UpcomingCreators';
import { ExhibitionTimeline } from '../components/creator/ExhibitionTimeline';
import { ProductGrid } from '../components/product/ProductGrid';
import { SectionHeading } from '../components/ui/SectionHeading';
import { isNewProduct } from '../utils/catalog';
import { getStatus } from '../utils/exhibition';
export function Home() {
  const newArrivals = products.filter(isNewProduct).sort((a, b) => b.addedAt.localeCompare(a.addedAt)).slice(0, 4);
  const timelineCreators = [...creators.filter(c => getStatus(c) === 'current').sort((a, b) => a.exhibitionEnd.localeCompare(b.exhibitionEnd)).slice(0, 6), ...creators.filter(c => getStatus(c) === 'upcoming')];
  return <>
      <Hero data-id="element-830" data-mp="2qxakm2cpppl5" />
      <CreatorMarquee data-id="element-831" data-mp="2qwsgkjjt672o" />
      <CategoryShowcase data-id="element-832" data-mp="2r0gdlsogpbm5" />
      <LastDaysCarousel data-id="element-833" data-mp="2mxjmteorq974" />

      <section className="mx-auto max-w-[1440px] px-5 py-16 md:px-8 md:py-24" aria-labelledby="calendrier-title" data-id="element-834" data-mp="2mw8k7i7277hl">
        <SectionHeading id="calendrier-title" title={<>
              Qui expose, <em className="text-clay" data-id="element-836" data-mp="2d5w17uew7mdk">jusqu’à quand</em>
            </>} description="Chaque créateur dispose d’environ trois mois en vitrine. Voici qui part bientôt et qui arrive." link={{
        to: '/createurs?vue=calendrier',
        label: 'Calendrier complet'
      }} data-id="element-835" data-mp="2hzi4ivz62dwp" />
        <ExhibitionTimeline creators={timelineCreators} data-id="element-837" data-mp="1z6wg2wql9pm5" />
      </section>

      <section className="mx-auto max-w-[1440px] px-5 pb-8 md:px-8" aria-labelledby="nouveautes-title" data-id="element-838" data-mp="1u9e2gt1mmm7t">
        <SectionHeading id="nouveautes-title" title={<>
              Tout juste <em className="text-clay" data-id="element-840" data-mp="1on3sy3vaacb9">arrivé</em>
            </>} description="Les pièces des créateurs installés ces dernières semaines." link={{
        to: '/boutique?tri=new',
        label: 'Toutes les nouveautés'
      }} data-id="element-839" data-mp="1kjnv547ha5wz" />
        <ProductGrid products={newArrivals} data-id="element-841" data-mp="1fngy60x284r6" />
      </section>

      <ConceptTeaser data-id="element-842" data-mp="23bqieyemkkg7" />
      <UpcomingCreators data-id="element-843" data-mp="23dbbskp7dxch" />
    </>;
}